// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"429":"52e724bd","453":"3c1b939b","471":"7e23e12d"}[chunkId] + ".chunk.js";
};